import PropTypes from "prop-types";
import React from "react";
import { usePersonalRecordGoalForm } from "../../../../hooks/goals/usePersonalRecordGoalForm";
import { PersonalRecordFields } from "../../profile/PersonalRecordFields";

// Create (no `goal`) or edit (`goal` passed) form for a Personal Record, in
// Periodization's manage-milestone-goals modal (see
// ~/.claude/plans/periodization-add-goal-modal.md Fase 6). State/validation/
// submit shared with AddGoal.js's own personalRecord branch via
// usePersonalRecordGoalForm - see that hook's own comment for why. Stays
// open on save (unlike AddGoal.js) via save-milestone-goal (see
// client-goals.js).
export const PersonalRecordInlineForm = ({
  t,
  unitsOptions,
  units,
  movementOptions,
  query,
  assert,
  flash,
  goal,
  onDone,
}) => {
  const {
    selectedExercise,
    onSelectExercise,
    targetReps,
    setTargetReps,
    targetLoad,
    setTargetLoad,
    setTargetUnits,
    targetDate,
    setTargetDate,
    isBlank,
    isUnchanged,
    submitPersonalRecord,
  } = usePersonalRecordGoalForm({
    goal,
    units,
    movementOptions,
    assert,
    flash,
    buildUrl: (id) =>
      id
        ? `/actions/client-goals/save-milestone-goal/${id}?proxyAthlete=${query.athlete}`
        : `/actions/client-goals/save-milestone-goal?proxyAthlete=${query.athlete}`,
  });
  const isSaveDisabled = isBlank || isUnchanged;

  return (
    <div className="inline-goal-form">
      <PersonalRecordFields
        t={t}
        movementOptions={movementOptions}
        unitsOptions={unitsOptions}
        units={units}
        selectedExercise={selectedExercise}
        onSelectExercise={onSelectExercise}
        targetReps={targetReps}
        setTargetReps={setTargetReps}
        targetLoad={targetLoad}
        setTargetLoad={setTargetLoad}
        setTargetUnits={setTargetUnits}
        targetDate={targetDate}
        setTargetDate={setTargetDate}
      />
      <div className="inline-form-actions">
        <button type="button" data-button-type="secondary" onClick={onDone}>
          {t("common:cancel")}
        </button>
        <button
          type="button"
          data-button-type="primary"
          disabled={isSaveDisabled}
          onClick={() => {
            submitPersonalRecord();
            onDone();
          }}
        >
          {t("common:save")}
        </button>
      </div>
    </div>
  );
};

PersonalRecordInlineForm.propTypes = {
  t: PropTypes.func.isRequired,
  unitsOptions: PropTypes.array.isRequired,
  units: PropTypes.string,
  movementOptions: PropTypes.array,
  query: PropTypes.object,
  assert: PropTypes.func.isRequired,
  flash: PropTypes.func.isRequired,
  goal: PropTypes.object,
  onDone: PropTypes.func.isRequired,
};
